import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { PageWrapper, TitleText, BasicText, BasicButton, ShortInput } from '@components';
import { validateEmail } from "@global";
import './login.css';
import { submitLogin } from '@actions';
import logo from '@images/logo.png';

const Login = ({
  submitLogin,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [error, setError] = useState(false);
  const history = useHistory();


  const validateForm = () => {
    return validateEmail(email) && password.length > 5;
  }

  useEffect(() => {
    setButtonDisabled(!validateForm());
  }, [email, password]);

  const handleSubmit = () => {
    setError(false);
    setLoading(true);
    submitLogin(
      {
        email,
        password
      },
      () => {
        history.push({
          pathname: '/admin',
        });
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  }

  return (

      <PageWrapper>
        <div className="login-container">
          <img src={logo} style={{ maxWidth: "100px", marginBottom: "30px" }} />

          <TitleText>
            Admin Login
          </TitleText>

          <div className="input_section">
            <ShortInput
              inputHeader="Enter Email"
              placeholder="joesmith@gmail.com"
              onChange={(val) => setEmail(val.toLowerCase().trim())}
              value={email}
            />
          </div>

          <div className="input_section">
            <ShortInput
              isPassword
              inputHeader="Enter Password"
              onChange={(val) => setPassword(val)}
              value={password}
            />
          </div>

          <BasicButton
            text="Submit"
            type="primary"
            style={{ width: "100%", marginTop: "20px", marginBottom: "20px" }}
            disabled={buttonDisabled}
            loading={loading}
            onClick={() => handleSubmit()}
          />

          {error && <BasicText color="red">{error}</BasicText>}
        </div>
      </PageWrapper>

  )
}

export default connect(null, {
  submitLogin
})(Login);
